<template>
<div class="kalem">
  <customdialog v-model="dialog" :maxWidth="options.width" title="title" :cardtextstyle="'height: 160px;'">

    <template slot="header">
      <v-tabs slot="extension" v-model="tabmodel">
        <v-tab :href="`#tab-tab1`">Tab1</v-tab>
        <v-tab :href="`#tab-tab2`">Tab2</v-tab>
      </v-tabs>
    </template>

    <v-tabs-items v-model="tabmodel">
      <v-tab-item :id="`tab-tab1`">
        tab 1
      </v-tab-item>
      <v-tab-item :id="`tab-tab2`">
        tab 2
      </v-tab-item>
    </v-tabs-items>
  </customdialog>

</div>
</template>

<script>
import customdialog from "@/components/app/coper/comp/customdialog.vue";

export default {
  data() {
    return {
      tabmodel: "tab-tab1",
      dialog: false,
      resolve: null,
      reject: null,

      options: {
        color: "primary",
        width: 350,
        message: null
      }
    };
  },
  components: {
    customdialog
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    yes() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>
